/* Approved collection entry: originals remain in flow and reveal at scroll top. */
(function(){
 'use strict';
 function canEnter(context){
  return !!(context.mobile&&context.root&&context.depth===1&&(context.homeOnly||context.brandParentOnly)&&
   context.navigation==='navigate'&&!context.hash&&context.scrollTop===0&&
   !context.interacted&&!context.scrolled&&!context.applied&&!context.editor);
 }
 function entryOffset(crumbBottom,scrollTop,brandHeight,navHeight,trustHeight){
  if(![crumbBottom,scrollTop,brandHeight,navHeight,trustHeight].every(Number.isFinite)||brandHeight<=0||navHeight<=0||trustHeight<=0)return null;
  return Math.max(0,Math.round(crumbBottom+scrollTop-brandHeight-navHeight-trustHeight));
 }
 // Pure policy is also exercised by local regression tests; no browser globals exported.
 if(typeof module==='object'&&module.exports){module.exports={canEnter:canEnter,entryOffset:entryOffset};return;}
 if(window.bmCollectionEntryInitialized)return;window.bmCollectionEntryInitialized=true;
 var interacted=false,scrolled=false,applied=false,abort=new AbortController(),signal=abort.signal;
 function gesture(){interacted=true;}
 ['wheel','touchstart','pointerdown','keydown','pagehide'].forEach(function(type){window.addEventListener(type,gesture,{passive:true,signal:signal});});
 window.addEventListener('scroll',function(){if(!applied&&scrollY!==0)scrolled=true;},{passive:true,signal:signal});
 function navigationType(){
  var entry=performance.getEntriesByType&&performance.getEntriesByType('navigation')[0];
  if(entry)return entry.type;
  return performance.navigation&&performance.navigation.type===0?'navigate':'unknown';
 }
 function applyEntry(){
  var crumb=document.querySelector('[data-bm-entry-root="true"]');
  var header=document.querySelector('header.bmh[data-native-sticky]');
  var brand=header&&header.querySelector('.bmh__brand'),menu=header&&header.querySelector('.bmh__nav');
  var shell=header&&header.closest('buildmat-header');
  var isBrand=!!(crumb&&crumb.dataset.bmEntryKind==='brand');
  var left=crumb&&crumb.querySelector('.left-breadcrumb'),trust=crumb&&crumb.querySelector(isBrand?'.c068-trust':'.right-breadcrumb');
  var home=left&&left.querySelector('[data-crumb-home="true"]');
  var visibleCrumbs=left?left.querySelectorAll('[data-crumb-index]:not([data-crumb-current])'):[];
  var context={mobile:matchMedia('(max-width:768px)').matches,root:!!crumb,depth:crumb?Number(crumb.dataset.bmEntryDepth):0,
   homeOnly:!isBrand&&!!home&&visibleCrumbs.length===1,
   brandParentOnly:isBrand&&!!home&&visibleCrumbs.length===2&&visibleCrumbs[1].getAttribute('href')==='/collections/brands',
   navigation:navigationType(),hash:location.hash,scrollTop:scrollY,
   interacted:interacted,scrolled:scrolled,applied:applied,editor:!!(window.Shopify&&Shopify.designMode)};
  if(!canEnter(context)||!brand||!menu||!shell||getComputedStyle(shell).position!=='sticky'||!left||!left.getClientRects().length||!trust||!trust.getClientRects().length){abort.abort();return;}
  var brandHeight=brand.getBoundingClientRect().height,navHeight=menu.getBoundingClientRect().height;
  // Header's deferred controller need not be ready for the first collection paint.
  crumb.style.setProperty('--bm-entry-header-height',(brandHeight+navHeight)+'px');
  var toolbar=shell.querySelector('#shopify-section-toolbar');
  if(toolbar)shell.style.setProperty('--bmh-toolbar-height',toolbar.getBoundingClientRect().height+'px');
  var destination=entryOffset(left.getBoundingClientRect().bottom,scrollY,brandHeight,navHeight,trust.getBoundingClientRect().height);
  // Keep the original trust-first order. Native sticky trust covers the breadcrumb
  // at entry; as the shopper scrolls up, that breadcrumb reveals underneath it.
  // The metadata nav bounds the sticky lifetime; no scroll handlers or swapping.
  if(destination===null||destination===0){abort.abort();return;}
  // The parser has not reached cards/footer yet. Reserve only the scroll range
  // needed now, then restore the original minimum once normal content exists.
  var body=document.body,minimum=body.style.getPropertyValue('min-height'),priority=body.style.getPropertyPriority('min-height');
  if(document.scrollingElement.scrollHeight<window.innerHeight+destination){
   body.style.setProperty('min-height',(window.innerHeight+destination)+'px');
   document.addEventListener('DOMContentLoaded',function(){
    if(minimum)body.style.setProperty('min-height',minimum,priority);else body.style.removeProperty('min-height');
   },{once:true});
  }
  applied=true;window.scrollTo({top:destination,behavior:'instant'});
  crumb.dataset.bmEntryState='applied';crumb.dataset.bmEntryReady=document.readyState;
  abort.abort();
 }
 // Called synchronously by the snippet after metadata parses, before title/cards.
 // No image, font, DOM-ready or animation-frame wait; no late fallback scroll.
 window.bmCollectionEntryPrepare=function(){delete window.bmCollectionEntryPrepare;applyEntry();};
})();
